var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedallaOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_71_1929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9186 8.60465L5.86047 2.15116L12.1395 0.0581395V6.27907C12.4027 7.87711 12.628 8.59506 13.1279 9.65116C10.5446 9.98634 9.22401 10.4911 7.0814 11.9186C6.43032 10.9573 6.22452 10.274 5.9186 8.60465Z",
    fill: "#E4FD3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1395 8.54651L22.1977 2.09302L15.9186 0V6.22093C15.6554 7.81897 15.4301 8.53692 14.9302 9.59302C17.5136 9.9282 18.8341 10.4329 20.9767 11.8605C21.6278 10.8992 21.8336 10.2158 22.1395 8.54651Z",
    fill: "#B2C633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.8605C8.47715 11.8605 4 16.3376 4 21.8605C4 24.8408 5.30378 27.5166 7.37209 29.3487L8.70123 27.0858C7.37603 25.7421 6.55814 23.8968 6.55814 21.8605C6.55814 17.7504 9.88997 14.4186 14 14.4186C14.6872 14.4186 15.3527 14.5118 15.9845 14.6861L17.314 12.4227C16.2768 12.0585 15.1615 11.8605 14 11.8605Z",
    fill: "#E4FD3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 31.8605C19.5228 31.8605 24 27.3833 24 21.8605C24 17.4992 21.208 13.79 17.314 12.4227L15.9845 14.6861C19.1311 15.5546 21.4419 18.4377 21.4419 21.8605C21.4419 25.9705 18.11 29.3023 14 29.3023C11.9263 29.3023 10.0507 28.4542 8.70123 27.0858L7.37209 29.3487C9.13658 30.9116 11.4575 31.8605 14 31.8605Z",
    fill: "#B2C633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 29.3023C18.11 29.3023 21.4419 25.9705 21.4419 21.8605C21.4419 18.4377 19.1311 15.5546 15.9845 14.6861L8.70123 27.0858C10.0507 28.4542 11.9263 29.3023 14 29.3023Z",
    fill: "#E4FD3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.4186C9.88997 14.4186 6.55814 17.7504 6.55814 21.8605C6.55814 23.8968 7.37603 25.7421 8.70123 27.0858L15.9845 14.6861C15.3527 14.5118 14.6872 14.4186 14 14.4186Z",
    fill: "#B2C633"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.373 27V18.96C13.365 18.968 13.273 18.992 13.097 19.032C12.929 19.072 12.737 19.112 12.521 19.152C12.305 19.192 12.113 19.228 11.945 19.26C11.777 19.292 11.689 19.308 11.681 19.308V18.336C11.817 18.304 11.973 18.26 12.149 18.204C12.333 18.148 12.517 18.08 12.701 18C12.893 17.92 13.073 17.82 13.241 17.7C13.417 17.58 13.565 17.44 13.685 17.28H14.657V27H13.373Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_71_1929",
    x: 0,
    y: 0,
    width: 28,
    height: 39.8605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_71_1929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_71_1929",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedallaOne);
export default __webpack_public_path__ + "static/media/medallaOne.4b7ae0dddff0a661b3bbb87b38c25424.svg";
export { ForwardRef as ReactComponent };